import { FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';

export const StyledSwitch = styled.div<{ $checked?: boolean }>`
  position: relative;
  width: 100%;
  height: 1.5rem;
  min-width: 1.5rem;
  max-width: 1.5rem;
  aspect-ratio: 1/1;
  margin-left: auto;

  transition: background-color ease 0.2s;
  background-color: ${({
    $checked,
    theme: {
      palette: {
        primary: { main },
      },
      shade,
    },
  }) => ($checked ? main : shade['200'])};

  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
    height: 100%;
    width: 100%;
    margin: 0;
    cursor: pointer;
  }

  .button-root {
    display: flex;
    position: absolute;
    margin: auto auto auto 2px;
    transition: margin-left ease 0.2s;
    height: 100%;
  }
  .button-base {
    margin: 2px 0;
    background-color: white;
    width: 5px;
  }

  input[value='true'] + .button-root {
    margin-left: calc(100% - 7px);
    margin-right: 2px;
  }

  :focus-within {
    outline: 1px solid
      ${({
        theme: {
          palette: {
            primary: { main },
          },
        },
      }) => main};
    outline-offset: 1px;
  }
`;
export const StyledFormControlLabel = styled(FormControlLabel)`
  gap: 1rem;
  margin-left: 0;
  margin-right: 0;
`;
